import {FC, memo, useRef} from 'react';
import {Box, Stack} from '@chakra-ui/react';
import {api, useT} from '@kcast-fe/core';
import {Control, Controller} from 'react-hook-form';
import {IPersonalizationForm, isPositiveNumber} from 'core';
import {Input, Select} from 'ui-kit';

interface IProps {
  control: Control<IPersonalizationForm>;
}

const BaseFieldsFormFC: FC<IProps> = ({control}) => {
  const {data: models = []} = api.catalogs.useModelsQuery();

  const containerRef = useRef<HTMLDivElement | null>(null);
  const {t} = useT();

  return (
    <Stack pb={'24px'} gap={'20px'} ref={containerRef}>
      <Controller
        control={control}
        name={`model_name_chat`}
        render={({field: {onChange, value}}) => (
          <Stack gap={'8px'}>
            <Box p={'0 4px'}>{t('fields.model_chat')}</Box>
            <Select
              value={value}
              onChange={onChange}
              container={containerRef}
              options={models.map((m) => ({value: m, label: m}))}
            />
          </Stack>
        )}
      />
      <Controller
        control={control}
        name={`model_name_voice`}
        render={({field: {onChange, value}}) => (
          <Stack gap={'8px'}>
            <Box p={'0 4px'}>{t('fields.model_voice')}</Box>
            <Select
              value={value}
              onChange={onChange}
              container={containerRef}
              options={models.map((m) => ({value: m, label: m}))}
            />
          </Stack>
        )}
      />
      <Controller
        control={control}
        name={`model_name_video`}
        render={({field: {onChange, value}}) => (
          <Stack gap={'8px'}>
            <Box p={'0 4px'}>{t('fields.model_video')}</Box>
            <Select
              value={value}
              onChange={onChange}
              container={containerRef}
              options={models.map((m) => ({value: m, label: m}))}
            />
          </Stack>
        )}
      />
      <Controller
        control={control}
        name={`ms_per_char`}
        rules={{validate: (value) => isPositiveNumber(value) || t('errors.positiveNumber')}}
        render={({field: {onChange, value}, fieldState: {error}}) => (
          <Stack gap={'8px'}>
            <Box p={'0 4px'}>{t('fields.ms_per_char')}</Box>
            <Input
              size={'lg'}
              inputMode={'decimal'}
              aria-label={t('fields.ms_per_char')}
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
            {error?.message && (
              <Box p={'0 4px'} fontSize={'12px'} color={'{colors.stateError}'}>
                {error.message}
              </Box>
            )}
          </Stack>
        )}
      />
    </Stack>
  );
};

export const BaseFieldsForm = memo(BaseFieldsFormFC);
